import React, { useState, useEffect } from "react";
//lidar com criptografias
// eslint-disable-next-line no-undef
const md5 = require("md5");
// lida com as requisições
import { api } from "services/api";
import { formatValue } from "services/globals";
// alteração no título da página no navegador
import { Helmet } from "react-helmet";
// reactstrap components
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  Table,
  CardBody,
} from "reactstrap";
import ModalLoading from "components/Loading/ModalLoading";

// eslint-disable-next-line no-undef
const moment = require("moment");

export function ComissaoProvisionada() {
  const [loading, setLoading] = useState(true);
  const [comissao, setComissao] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(
          `relatorios/comissao-provisionada/${sessionStorage.getItem(
            md5("CODUSU")
          )}`
        );
        if (response.data?.statusApi == 1) {
          const { comissaoProvisionada } = response.data;
          //console.log(comissaoProvisionada)
          setComissao(comissaoProvisionada);
        } else {
          console.error("comissao-provisionada->status 2", response.data);
        }
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Relatório | Comissão Provisionada</title>
      </Helmet>
      <div className="content">
        <Row>
          <Col>
            {comissao != null ? (
              <Card className="card-chart">
                <CardHeader>
                  <h4>Comissão Provisionada</h4>
                  <CardTitle tag="h3">
                    <i className="tim-icons icon-bell-55 text-primary" />
                    {comissao.length} Títulos
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th className="text-left">Cliente</th>
                        <th className="text-left">Operação</th>
                        <th className="text-right">#Nota</th>
                        <th className="text-right">Nº Nota</th>
                        <th className="text-right">Nº Fin.</th>
                        <th className="text-right">Dt. Neg.</th>
                        <th className="text-right">Dt. Venc.</th>
                        <th className="text-right">Dt. Baixa.</th>
                        <th className="text-right">Com (%)</th>
                        <th className="text-right">Com (R$)</th>
                        <th className="text-left">Tipo Titulo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {comissao.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td className="text-left">
                              {item.CODPARC + " - " + item.NOMEPARC}
                            </td>
                            <td className="text-left">{item.DESCROPER}</td>
                            <td className="text-right">{item.NUNOTA}</td>
                            <td className="text-right">{item.NUMNOTA}</td>
                            <td className="text-right">{item.FINNUFIN}</td>
                            <td className="text-right">
                              {moment(item.DTNEG).format("DD/MM/YYYY")}
                            </td>
                            <td className="text-right">
                              {moment(item.DTVENC).format("DD/MM/YYYY")}
                            </td>
                            <td className="text-right">
                              {moment(item.DHBAIXA).format("DD/MM/YYYY")}
                            </td>
                            <td className="text-right">
                              {formatValue("decimal", item.PERCCOM)}
                            </td>
                            <td className="text-right">
                              {formatValue("currency", item.COMLIQ)}
                            </td>
                            <td className="text-left">
                              {item.CODTIPTIT + " - " + item.DESCRTIPTIT}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </div>
      <ModalLoading loading={loading} mensagem={"Carregando Relatório"} />
    </>
  );
}
